const analytics = {
  analytics: 'Аналитика',
  sdAnalytics: 'Аналитика СД',
  sdAnalyticsEmpty: 'По данному клиенту пока нет истории работы',
  kfAnalytics: 'Аналитика контур фокус',
  debtor: 'Дебитор',
  debtorName: 'Имя дебитора',
  debtorCode: 'Код дебитора',
  revenueAnalysis: 'Анализ выручки',
  extraChargeAnalysis: 'Анализ наценки',
  grossProfitAnalysis: 'Анализ валовой прибыли',
  paymentsAnalysis: 'Анализ платежей',
  overdueDzAnalysis: 'Анализ просроченной ДЗ',
  daysPastDueAnalysis: 'Анализ дней просрочки',
  analyticsFor: 'Аналитика за',
  emptyAnalytics: 'Отсутствует аналитика',
  forAllYears: 'За все годы',
  companyAffiliates: 'Аффилированные компании',
  beneficiaries: 'Бенефициары',
  listOfCompanyAffiliates: 'Список аффилированных компаний',
  listOfBeneficiaries: 'Список бенефициаров',
  executiveProceedings: 'Исполнительные производства',
  governmentContracts: 'Госконтракты',
  listOfContracts: 'Список контрактов',
  listOfExecutiveProceeding: 'Список исполнительных производств',
  emptyDebtorAnalytics: 'По данному дебитору отсутствует какая-либо аналитика',
};

export default analytics;
